import React from 'react';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6 text-white">개인정보처리방침</h1>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">1. 개인정보의 처리 목적</h2>
          <p className="text-gray-300">
            My Radio DB(이하 '서비스')는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는
            개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는
            개인정보 보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
          </p>
          <ul className="list-disc list-inside text-gray-300 ml-4 mt-2">
            <li>회원 가입 및 관리 : 없음</li>
            <li>서비스 제공 : 배철수 음악캠프 그날의 선곡표 유투브 뮤직 셋리스트 저장 기능</li>
            <li>
              문의 처리 :{' '}
              <a
                href="https://www.threads.net/@yaongpainter"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-400 hover:underline"
              >
                @Threads
              </a>
              에 문의하세요.
            </li>
            {/* 추가 목적 기재 */}
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">2. 처리하는 개인정보 항목</h2>
          <p className="text-gray-300">서비스는 다음의 개인정보 항목을 처리하고 있습니다.</p>
          <ul className="list-disc list-inside text-gray-300 ml-4 mt-2">
            <li>필수 항목: 아무 것도 저장하지 않습니다.</li>
            <li>선택 항목: 아무 것도 저장하지 않습니다.</li>
            {/* 추가 항목 기재 */}
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">
            3. 개인정보의 처리 및 보유 기간
          </h2>
          <p className="text-gray-300">
            법령에 따른 개인정보 보유·이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은
            개인정보 보유·이용기간 내에서 개인정보를 처리·보유합니다.
          </p>
          {/* 구체적인 보유 기간 명시 */}
        </section>

        {/* 추가 조항들 (개인정보의 제3자 제공, 처리 위탁, 정보주체의 권리·의무 및 행사방법 등) */}

        <section className="mb-6">
          <h2 className="text-2xl font-semibold mb-3 text-white">4. 개인정보처리방침 변경</h2>
          <p className="text-gray-300">
            이 개인정보처리방침은 시행일로부터 적용되며, 법령 및 방침에 따른 변경내용의 추가, 삭제
            및 정정이 있는 경우에는 변경사항의 시행 7일 전부터 공지사항을 통하여 고지할 것입니다.
          </p>
        </section>

        <section>
          <p className="text-sm text-gray-300">시행일자: 2025년 1월 13일</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
